import { SettingActionType } from '../action-types/settingTypes';
import { SettingActions } from '../actions/settingTypes';

interface SettingsState {
  initialised: boolean;
  partnerId: string;
  currentSteps: Array<number>;
  sessionId: string;
  appName: string;
  clientId: string;
  productCategory: string;
  uuid: string;
  loggerLink: string;
  environment: Stage;
  language: LanguageType;
  tipmode: boolean;
  promptagent: boolean;
  externalReference: string;
  confirmationtarget: string;
  confirmationtype: string;
  rebound: Rebound;
  precontractualQuoteId: number;
  agencyInformation: AgencyInformationType | null;
  currentDate: string;
}

const initialState: SettingsState = {
  initialised: false,
  partnerId: '',
  currentSteps: [1],
  sessionId: '',
  uuid: '',
  appName: '',
  clientId: 'ba4',
  productCategory: 'standard',
  loggerLink: '',
  environment: 'PROD',
  language: 'de',
  tipmode: false,
  promptagent: false,
  externalReference: '',
  confirmationtarget: '',
  confirmationtype: '',
  rebound: { keys: [], values: [] },
  precontractualQuoteId: 0,
  agencyInformation: null,
  currentDate: new Date().toISOString().split('T')[0],
};

const settingsReducer = (state: SettingsState = initialState, action: SettingActions) => {
  switch (action.type) {
    case SettingActionType.IS_INITIALISED:
      return {
        ...state,
        initialised: action.payload,
      };
    case SettingActionType.SET_PARTNER_ID:
      return {
        ...state,
        partnerId: action.payload,
      };
    case SettingActionType.SET_CURRENT_STEPS:
      return {
        ...state,
        currentSteps: action.payload,
      };
    case SettingActionType.SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.sessionId,
      };
    case SettingActionType.SET_APP_NAME:
      return {
        ...state,
        appName: action.payload,
      };
    case SettingActionType.SET_UUID:
      return {
        ...state,
        uuid: action.payload,
      };
    case SettingActionType.SET_LOGGER_LINK:
      return {
        ...state,
        loggerLink: action.payload,
      };
    case SettingActionType.SET_ENVIRONMENT:
      return {
        ...state,
        environment: action.payload,
      };
    case SettingActionType.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case SettingActionType.SET_TIPMODE:
      return {
        ...state,
        tipmode: action.payload,
      };
    case SettingActionType.SET_PROMPT_AGENT:
      return {
        ...state,
        promptagent: action.payload,
      };
    case SettingActionType.SET_EXTERNAL_REFERENCE:
      return {
        ...state,
        externalReference: action.payload,
      };
    case SettingActionType.SET_CONFIRMATION_TARGET:
      return {
        ...state,
        confirmationtarget: action.payload,
      };
    case SettingActionType.SET_CONFIRMATION_TYPE:
      return {
        ...state,
        confirmationtype: action.payload,
      };
    case SettingActionType.SET_REBOUND:
      return {
        ...state,
        rebound: action.payload,
      };
    case SettingActionType.SET_PRECONTRACTUAL_QUOTEID:
      return {
        ...state,
        precontractualQuoteId: action.payload,
      };
    case SettingActionType.SET_AGENCY_INFORMATION:
      return {
        ...state,
        agencyInformation: action.payload,
      };
    default:
      return state;
  }
};

export default settingsReducer;
